'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var searchAddress = exports.searchAddress = function searchAddress() {
  return Promise.reject(new Error('This method is not supported by JustGiving'));
};

var getAddressDetails = exports.getAddressDetails = function getAddressDetails() {
  return Promise.reject(new Error('This method is not supported by JustGiving'));
};

var deserializeAddress = exports.deserializeAddress = function deserializeAddress() {
  return Promise.reject(new Error('This method is not supported by JustGiving'));
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/address/justgiving/index.js
// module id = 1312
// module chunks = 0